/**
 * Generate path for given segments
 * Separates segments with '/'
 *
 * @param segments<string[]>
 * @param baseSlash<boolean>
 * @param trailingSlash<boolean>
 *
 * @return string
 */
export function path(
    segments: string[],
    baseSlash: boolean = true,
    trailingSlash: boolean = false
): string {
    let result: string = segments
        .map(segment => segment.replace(/^\//, '').replace(/\/$/, ''))
        .join('/');

    if (baseSlash && !result.match(new RegExp('^https?://'))) {
        result = `/${result}`;
    }

    if (trailingSlash && !result.match(/\/$/)) {
        result = `${result}/`;
    }

    return result;
}